/**
 * Implements a KendoUI RangeSlider as a Marionette Behavior.
 */

import Marionette from "backbone.marionette";

import "kendo.core";
import "kendo.slider";

import "../../../../sass/kendoui-slider.scss";

const WRAPPER_ELEMENT = ".form-group";
const LABEL_ELEMENT = ".selected-value";

class RangeSlider extends Marionette.Behavior {
  defaults() {
    return {
      selector: ".range-slider",
      opts: {
        tickPlacement: "both",
        min: 1,
        max: 10,
        smallStep: 1,
        tooltip: {
          enabled: true,
        },
        change: this._onChange.bind(this),
      },
    };
  }

  events() {
    return {
      "shown.bs.dropdown": "_onDropdownShown",
    };
  }

  initialize() {
    this.rendered = false;

    // merge defaults and user options
    _.defaults(this.options.opts, this.defaults.opts);
  }

  _onDropdownShown() {
    if (!this.rendered) {
      const self = this;

      this.$(this.options.selector).each(function () {
        const $el = $(this);
        const data = $el.data();

        // console.groupCollapsed(this.id)
        // console.log("before", _.clone(data))

        // remove invalid small step value
        if (_.isNumber(data.smallStep) && data.smallStep < 1) {
          delete data.smallStep;
        }

        // pull starting values
        if (Array.isArray(data.value) && data.value.length === 2) {
          data.selectionStart = data.value[0];
          data.selectionEnd = data.value[1];
          delete data.value;
        } else {
          delete data.value;
        }

        // inject format when passed in
        if (data.format) {
          data.tooltip = {
            enabled: true,
            format: data.format,
          };
        }

        // determine if component should be inaccessible
        data.locked = false;
        try {
          data.locked = data.max - data.min === 0;
        } catch (err) {
          // ignore
        }

        // console.log("after", data)
        // console.groupEnd(this.id)

        const options = Object.assign({}, self.options.opts, data);

        // instantiate slider
        const $slider = $el.kendoRangeSlider(options);

        // run post instantiation logic
        self._setLabel($slider.getKendoRangeSlider());
      });

      this.rendered = true;
    }
  }

  /**
   * Sets initial control label
   * @param {jQuery selector} $slider
   */
  _setLabel(api) {
    try {
      const wrapper = api.wrapper.closest(WRAPPER_ELEMENT);
      const $label = $(LABEL_ELEMENT, wrapper);
      const label = this._labelFormatter(api.options);
      $label.html(label);
      api.options.locked && wrapper.addClass("locked");
    } catch (err) {
      console.error(err.stack);
    }
  }

  /**
   * Updates control label
   * @param {Kendo Event} e
   */
  _onChange(e) {
    this._setLabel(e.sender);
  }

  _labelFormatter(options) {
    const { format, selectionStart: start, selectionEnd: end } = options;
    let label = "";
    if (_.isString(format) && _.isNumber(start) && _.isNumber(end)) {
      try {
        label = `${kendo.format(format, start)} to ${kendo.format(
          format,
          end
        )}`;
      } catch (err) {
        console.error(err.stack);
      }
    }
    return label;
  }
}

export { RangeSlider as default };
